import {
    LifecycleConnection,
    LifecycleConnectionCreate,
} from "server/models"
import { GET, POST, DELETE } from "client/store/utils"

const CreateConnectionDetails = (connections: LifecycleConnection[]) => {
    const connectionList: LifecycleConnection[] = []
    connections.forEach((connection) => {
        connectionList.push({
            ...connection,
            pointsArray: connection.points ? JSON.parse(connection.points) : null,
        })
    })
    return connectionList
}

export const LoadAllLifecycleConnections = (lifecycleId: number) => (
    GET(`/lifecycleConnection/all/lifecycle/${lifecycleId}`)
    .then((connections: LifecycleConnection[]) => (
        CreateConnectionDetails(connections)
    ))
)

export const LoadLifecycleConnections = (lifecycleId: number, phaseId: number) => (
    GET(`/lifecycleConnection/lifecycle/${lifecycleId}/phase/${phaseId}`)
    .then((connections: LifecycleConnection[]) => (
        CreateConnectionDetails(connections)
    ))
)

export const LoadLifecycleConnectionsConnectedTo = (phaseId: number) => (
    GET(`/lifecycleConnection/connectedTo/${phaseId}`)
    .then((connections: LifecycleConnection[]) => (
        CreateConnectionDetails(connections)
    ))
)

export const AddLifecycleConnection = (connection: LifecycleConnectionCreate) => (
    POST(
        "/lifecycleConnection/add",
        JSON.stringify(connection),
    ).then((res) => {
        const newConnection = res as LifecycleConnection
        return newConnection.id || null
    })
)

export const UpdateLifecycleConnection = (connection: LifecycleConnectionCreate) => (
    POST(
        "/lifecycleConnection/update",
        JSON.stringify(connection),
    )
)

export const UpdateManyLifecycleConnections = (connections: LifecycleConnection[]) => (
    POST(
        "/lifecycleConnection/updateMany",
        JSON.stringify(connections),
    )
)

export const DeleteLifecycleConnection = (connectionId: string) => (
    DELETE(`/lifecycleConnection/delete/${connectionId}`)
    .then((removedRows: number) => removedRows)
)
